import { TD } from '@/components/DesignLibrary/Table';

export type Props = {
  type: 'text';
  content: string;
};

const TextCell: React.FC<Props> = ({ content }) => {
  if (content.length > 200) {
    return (
      <TD>
        <p className="caption" style={{ minWidth: 320 }}>
          {content}
        </p>
      </TD>
    );
  }
  return <TD label={content} compact />;
};

export default TextCell;
